import { css as e, jsx as r } from "@emotion/core";
import t, { useContext as a, createContext as n } from "react";
var s = function () {
  return (s = Object.assign || function (e) {
    for (var r, t = 1, a = arguments.length; t < a; t++) for (var n in r = arguments[t]) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    return e;
  }).apply(this, arguments);
};
function c(e, r) {
  var t = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && r.indexOf(a) < 0 && (t[a] = e[a]);
  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var n = 0;
    for (a = Object.getOwnPropertySymbols(e); n < a.length; n++) r.indexOf(a[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (t[a[n]] = e[a[n]]);
  }
  return t;
}
var i = function () {
  function e(e) {
    this.isSpeedy = void 0 === e.speedy ? "production" === process.env.NODE_ENV : e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.before = null;
  }
  var r = e.prototype;
  return r.insert = function (e) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) == 0) {
      var r,
        t = function (e) {
          var r = document.createElement("style");
          return r.setAttribute("data-emotion", e.key), void 0 !== e.nonce && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r;
        }(this);
      r = 0 === this.tags.length ? this.before : this.tags[this.tags.length - 1].nextSibling, this.container.insertBefore(t, r), this.tags.push(t);
    }
    var a = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var n = function (e) {
        if (e.sheet) return e.sheet;
        for (var r = 0; r < document.styleSheets.length; r++) if (document.styleSheets[r].ownerNode === e) return document.styleSheets[r];
      }(a);
      try {
        var s = 105 === e.charCodeAt(1) && 64 === e.charCodeAt(0);
        n.insertRule(e, s ? 0 : n.cssRules.length);
      } catch (r) {
        "production" !== process.env.NODE_ENV && console.warn('There was a problem inserting the following rule: "' + e + '"', r);
      }
    } else a.appendChild(document.createTextNode(e));
    this.ctr++;
  }, r.flush = function () {
    this.tags.forEach(function (e) {
      return e.parentNode.removeChild(e);
    }), this.tags = [], this.ctr = 0;
  }, e;
}();
function o(e) {
  function r(e, a, o, l, d) {
    for (var h, b, p, v, m, C = 0, A = 0, x = 0, O = 0, E = 0, P = 0, V = p = h = 0, I = 0, _ = 0, R = 0, H = 0, B = o.length, F = B - 1, W = "", q = "", M = "", Y = ""; I < B;) {
      if (b = o.charCodeAt(I), I === F && 0 !== A + O + x + C && (0 !== A && (b = 47 === A ? 10 : 47), O = x = C = 0, B++, F++), 0 === A + O + x + C) {
        if (I === F && (0 < _ && (W = W.replace(f, "")), 0 < W.trim().length)) {
          switch (b) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              W += o.charAt(I);
          }
          b = 59;
        }
        switch (b) {
          case 123:
            for (h = (W = W.trim()).charCodeAt(0), p = 1, H = ++I; I < B;) {
              switch (b = o.charCodeAt(I)) {
                case 123:
                  p++;
                  break;
                case 125:
                  p--;
                  break;
                case 47:
                  switch (b = o.charCodeAt(I + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (V = I + 1; V < F; ++V) switch (o.charCodeAt(V)) {
                          case 47:
                            if (42 === b && 42 === o.charCodeAt(V - 1) && I + 2 !== V) {
                              I = V + 1;
                              break e;
                            }
                            break;
                          case 10:
                            if (47 === b) {
                              I = V + 1;
                              break e;
                            }
                        }
                        I = V;
                      }
                  }
                  break;
                case 91:
                  b++;
                case 40:
                  b++;
                case 34:
                case 39:
                  for (; I++ < F && o.charCodeAt(I) !== b;);
              }
              if (0 === p) break;
              I++;
            }
            switch (p = o.substring(H, I), 0 === h && (h = (W = W.replace(u, "").trim()).charCodeAt(0)), h) {
              case 64:
                switch (0 < _ && (W = W.replace(f, "")), b = W.charCodeAt(1)) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    _ = a;
                    break;
                  default:
                    _ = T;
                }
                if (H = (p = r(a, _, p, b, d + 1)).length, 0 < z && (m = i(3, p, _ = t(T, W, R), a, $, N, H, b, d, l), W = _.join(""), void 0 !== m && 0 === (H = (p = m.trim()).length) && (b = 0, p = "")), 0 < H) switch (b) {
                  case 115:
                    W = W.replace(y, c);
                  case 100:
                  case 109:
                  case 45:
                    p = W + "{" + p + "}";
                    break;
                  case 107:
                    p = (W = W.replace(g, "$1 $2")) + "{" + p + "}", p = 1 === S || 2 === S && s("@" + p, 3) ? "@-webkit-" + p + "@" + p : "@" + p;
                    break;
                  default:
                    p = W + p, 112 === l && (q += p, p = "");
                } else p = "";
                break;
              default:
                p = r(a, t(a, W, R), p, l, d + 1);
            }
            M += p, p = R = _ = V = h = 0, W = "", b = o.charCodeAt(++I);
            break;
          case 125:
          case 59:
            if (1 < (H = (W = (0 < _ ? W.replace(f, "") : W).trim()).length)) switch (0 === V && (h = W.charCodeAt(0), 45 === h || 96 < h && 123 > h) && (H = (W = W.replace(" ", ":")).length), 0 < z && void 0 !== (m = i(1, W, a, e, $, N, q.length, l, d, l)) && 0 === (H = (W = m.trim()).length) && (W = "\0\0"), h = W.charCodeAt(0), b = W.charCodeAt(1), h) {
              case 0:
                break;
              case 64:
                if (105 === b || 99 === b) {
                  Y += W + o.charAt(I);
                  break;
                }
              default:
                58 !== W.charCodeAt(H - 1) && (q += n(W, h, b, W.charCodeAt(2)));
            }
            R = _ = V = h = 0, W = "", b = o.charCodeAt(++I);
        }
      }
      switch (b) {
        case 13:
        case 10:
          47 === A ? A = 0 : 0 === 1 + h && 107 !== l && 0 < W.length && (_ = 1, W += "\0"), 0 < z * D && i(0, W, a, e, $, N, q.length, l, d, l), N = 1, $++;
          break;
        case 59:
        case 125:
          if (0 === A + O + x + C) {
            N++;
            break;
          }
        default:
          switch (N++, v = o.charAt(I), b) {
            case 9:
            case 32:
              if (0 === O + C + A) switch (E) {
                case 44:
                case 58:
                case 9:
                case 32:
                  v = "";
                  break;
                default:
                  32 !== b && (v = " ");
              }
              break;
            case 0:
              v = "\\0";
              break;
            case 12:
              v = "\\f";
              break;
            case 11:
              v = "\\v";
              break;
            case 38:
              0 === O + A + C && (_ = R = 1, v = "\f" + v);
              break;
            case 108:
              if (0 === O + A + C + j && 0 < V) switch (I - V) {
                case 2:
                  112 === E && 58 === o.charCodeAt(I - 3) && (j = E);
                case 8:
                  111 === P && (j = P);
              }
              break;
            case 58:
              0 === O + A + C && (V = I);
              break;
            case 44:
              0 === A + x + O + C && (_ = 1, v += "\r");
              break;
            case 34:
            case 39:
              0 === A && (O = O === b ? 0 : 0 === O ? b : O);
              break;
            case 91:
              0 === O + A + x && C++;
              break;
            case 93:
              0 === O + A + x && C--;
              break;
            case 41:
              0 === O + A + C && x--;
              break;
            case 40:
              if (0 === O + A + C) {
                if (0 === h) switch (2 * E + 3 * P) {
                  case 533:
                    break;
                  default:
                    h = 1;
                }
                x++;
              }
              break;
            case 64:
              0 === A + x + O + C + V + p && (p = 1);
              break;
            case 42:
            case 47:
              if (!(0 < O + C + x)) switch (A) {
                case 0:
                  switch (2 * b + 3 * o.charCodeAt(I + 1)) {
                    case 235:
                      A = 47;
                      break;
                    case 220:
                      H = I, A = 42;
                  }
                  break;
                case 42:
                  47 === b && 42 === E && H + 2 !== I && (33 === o.charCodeAt(H + 2) && (q += o.substring(H, I + 1)), v = "", A = 0);
              }
          }
          0 === A && (W += v);
      }
      P = E, E = b, I++;
    }
    if (0 < (H = q.length)) {
      if (_ = a, 0 < z && void 0 !== (m = i(2, q, _, e, $, N, H, l, d, l)) && 0 === (q = m).length) return Y + q + M;
      if (q = _.join(",") + "{" + q + "}", 0 != S * j) {
        switch (2 !== S || s(q, 2) || (j = 0), j) {
          case 111:
            q = q.replace(w, ":-moz-$1") + q;
            break;
          case 112:
            q = q.replace(k, "::-webkit-input-$1") + q.replace(k, "::-moz-$1") + q.replace(k, ":-ms-input-$1") + q;
        }
        j = 0;
      }
    }
    return Y + q + M;
  }
  function t(e, r, t) {
    var n = r.trim().split(p);
    r = n;
    var s = n.length,
      c = e.length;
    switch (c) {
      case 0:
      case 1:
        var i = 0;
        for (e = 0 === c ? "" : e[0] + " "; i < s; ++i) r[i] = a(e, r[i], t).trim();
        break;
      default:
        var o = i = 0;
        for (r = []; i < s; ++i) for (var l = 0; l < c; ++l) r[o++] = a(e[l] + " ", n[i], t).trim();
    }
    return r;
  }
  function a(e, r, t) {
    var a = r.charCodeAt(0);
    switch (33 > a && (a = (r = r.trim()).charCodeAt(0)), a) {
      case 38:
        return r.replace(v, "$1" + e.trim());
      case 58:
        return e.trim() + r.replace(v, "$1" + e.trim());
      default:
        if (0 < 1 * t && 0 < r.indexOf("\f")) return r.replace(v, (58 === e.charCodeAt(0) ? "" : "$1") + e.trim());
    }
    return e + r;
  }
  function n(e, r, t, a) {
    var c = e + ";",
      i = 2 * r + 3 * t + 4 * a;
    if (944 === i) {
      e = c.indexOf(":", 9) + 1;
      var o = c.substring(e, c.length - 1).trim();
      return o = c.substring(0, e).trim() + o + ";", 1 === S || 2 === S && s(o, 1) ? "-webkit-" + o + o : o;
    }
    if (0 === S || 2 === S && !s(c, 1)) return c;
    switch (i) {
      case 1015:
        return 97 === c.charCodeAt(10) ? "-webkit-" + c + c : c;
      case 951:
        return 116 === c.charCodeAt(3) ? "-webkit-" + c + c : c;
      case 963:
        return 110 === c.charCodeAt(5) ? "-webkit-" + c + c : c;
      case 1009:
        if (100 !== c.charCodeAt(4)) break;
      case 969:
      case 942:
        return "-webkit-" + c + c;
      case 978:
        return "-webkit-" + c + "-moz-" + c + c;
      case 1019:
      case 983:
        return "-webkit-" + c + "-moz-" + c + "-ms-" + c + c;
      case 883:
        if (45 === c.charCodeAt(8)) return "-webkit-" + c + c;
        if (0 < c.indexOf("image-set(", 11)) return c.replace(E, "$1-webkit-$2") + c;
        break;
      case 932:
        if (45 === c.charCodeAt(4)) switch (c.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + c.replace("-grow", "") + "-webkit-" + c + "-ms-" + c.replace("grow", "positive") + c;
          case 115:
            return "-webkit-" + c + "-ms-" + c.replace("shrink", "negative") + c;
          case 98:
            return "-webkit-" + c + "-ms-" + c.replace("basis", "preferred-size") + c;
        }
        return "-webkit-" + c + "-ms-" + c + c;
      case 964:
        return "-webkit-" + c + "-ms-flex-" + c + c;
      case 1023:
        if (99 !== c.charCodeAt(8)) break;
        return "-webkit-box-pack" + (o = c.substring(c.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify")) + "-webkit-" + c + "-ms-flex-pack" + o + c;
      case 1005:
        return h.test(c) ? c.replace(d, ":-webkit-") + c.replace(d, ":-moz-") + c : c;
      case 1e3:
        switch (r = (o = c.substring(13).trim()).indexOf("-") + 1, o.charCodeAt(0) + o.charCodeAt(r)) {
          case 226:
            o = c.replace(m, "tb");
            break;
          case 232:
            o = c.replace(m, "tb-rl");
            break;
          case 220:
            o = c.replace(m, "lr");
            break;
          default:
            return c;
        }
        return "-webkit-" + c + "-ms-" + o + c;
      case 1017:
        if (-1 === c.indexOf("sticky", 9)) break;
      case 975:
        switch (r = (c = e).length - 10, i = (o = (33 === c.charCodeAt(r) ? c.substring(0, r) : c).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | o.charCodeAt(7))) {
          case 203:
            if (111 > o.charCodeAt(8)) break;
          case 115:
            c = c.replace(o, "-webkit-" + o) + ";" + c;
            break;
          case 207:
          case 102:
            c = c.replace(o, "-webkit-" + (102 < i ? "inline-" : "") + "box") + ";" + c.replace(o, "-webkit-" + o) + ";" + c.replace(o, "-ms-" + o + "box") + ";" + c;
        }
        return c + ";";
      case 938:
        if (45 === c.charCodeAt(5)) switch (c.charCodeAt(6)) {
          case 105:
            return o = c.replace("-items", ""), "-webkit-" + c + "-webkit-box-" + o + "-ms-flex-" + o + c;
          case 115:
            return "-webkit-" + c + "-ms-flex-item-" + c.replace(A, "") + c;
          default:
            return "-webkit-" + c + "-ms-flex-line-pack" + c.replace("align-content", "").replace(A, "") + c;
        }
        break;
      case 973:
      case 989:
        if (45 !== c.charCodeAt(3) || 122 === c.charCodeAt(4)) break;
      case 931:
      case 953:
        if (!0 === O.test(e)) return 115 === (o = e.substring(e.indexOf(":") + 1)).charCodeAt(0) ? n(e.replace("stretch", "fill-available"), r, t, a).replace(":fill-available", ":stretch") : c.replace(o, "-webkit-" + o) + c.replace(o, "-moz-" + o.replace("fill-", "")) + c;
        break;
      case 962:
        if (c = "-webkit-" + c + (102 === c.charCodeAt(5) ? "-ms-" + c : "") + c, 211 === t + a && 105 === c.charCodeAt(13) && 0 < c.indexOf("transform", 10)) return c.substring(0, c.indexOf(";", 27) + 1).replace(b, "$1-webkit-$2") + c;
    }
    return c;
  }
  function s(e, r) {
    var t = e.indexOf(1 === r ? ":" : "{"),
      a = e.substring(0, 3 !== r ? t : 10);
    return t = e.substring(t + 1, e.length - 1), V(2 !== r ? a : a.replace(x, "$1"), t, r);
  }
  function c(e, r) {
    var t = n(r, r.charCodeAt(0), r.charCodeAt(1), r.charCodeAt(2));
    return t !== r + ";" ? t.replace(C, " or ($1)").substring(4) : "(" + r + ")";
  }
  function i(e, r, t, a, n, s, c, i, o, u) {
    for (var f, d = 0, h = r; d < z; ++d) switch (f = P[d].call(l, e, h, t, a, n, s, c, i, o, u)) {
      case void 0:
      case !1:
      case !0:
      case null:
        break;
      default:
        h = f;
    }
    if (h !== r) return h;
  }
  function o(e) {
    return void 0 !== (e = e.prefix) && (V = null, e ? "function" != typeof e ? S = 1 : (S = 2, V = e) : S = 0), o;
  }
  function l(e, t) {
    var a = e;
    if (33 > a.charCodeAt(0) && (a = a.trim()), a = [a], 0 < z) {
      var n = i(-1, t, a, a, $, N, 0, 0, 0, 0);
      void 0 !== n && "string" == typeof n && (t = n);
    }
    var s = r(T, a, t, 0, 0);
    return 0 < z && void 0 !== (n = i(-2, s, a, a, $, N, s.length, 0, 0, 0)) && (s = n), "", j = 0, N = $ = 1, s;
  }
  var u = /^\0+/g,
    f = /[\0\r\f]/g,
    d = /: */g,
    h = /zoo|gra/,
    b = /([,: ])(transform)/g,
    p = /,\r+?/g,
    v = /([\t\r\n ])*\f?&/g,
    g = /@(k\w+)\s*(\S*)\s*/,
    k = /::(place)/g,
    w = /:(read-only)/g,
    m = /[svh]\w+-[tblr]{2}/,
    y = /\(\s*(.*)\s*\)/g,
    C = /([\s\S]*?);/g,
    A = /-self|flex-/g,
    x = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
    O = /stretch|:\s*\w+\-(?:conte|avail)/,
    E = /([^-])(image-set\()/,
    N = 1,
    $ = 1,
    j = 0,
    S = 1,
    T = [],
    P = [],
    z = 0,
    V = null,
    D = 0;
  return l.use = function e(r) {
    switch (r) {
      case void 0:
      case null:
        z = P.length = 0;
        break;
      default:
        if ("function" == typeof r) P[z++] = r;else if ("object" == typeof r) for (var t = 0, a = r.length; t < a; ++t) e(r[t]);else D = 0 | !!r;
    }
    return e;
  }, l.set = o, void 0 !== e && o(e), l;
}
var l = function (e) {
  var r = new WeakMap();
  return function (t) {
    if (r.has(t)) return r.get(t);
    var a = e(t);
    return r.set(t, a), a;
  };
};
function u(e) {
  e && b.current.insert(e + "}");
}
var f,
  d,
  h,
  b = {
    current: null
  },
  p = function (e, r, t, a, n, s, c, i, o, l) {
    switch (e) {
      case 1:
        switch (r.charCodeAt(0)) {
          case 64:
            return b.current.insert(r + ";"), "";
          case 108:
            if (98 === r.charCodeAt(2)) return "";
        }
        break;
      case 2:
        if (0 === i) return r + "/*|*/";
        break;
      case 3:
        switch (i) {
          case 102:
          case 112:
            return b.current.insert(t[0] + r), "";
          default:
            return r + (0 === l ? "/*|*/" : "");
        }
      case -2:
        r.split("/*|*/}").forEach(u);
    }
  },
  v = function (e, r) {
    if (1 === e && 108 === r.charCodeAt(0) && 98 === r.charCodeAt(2)) return "";
  },
  g = "undefined" != typeof document,
  k = {},
  w = g ? void 0 : l(function () {
    var e = l(function () {
        return {};
      }),
      r = {},
      t = {};
    return function (a) {
      return void 0 === a || !0 === a ? r : !1 === a ? t : e(a);
    };
  });
!function (e) {
  void 0 === e && (e = {});
  var r,
    t = e.key || "css";
  void 0 !== e.prefix && (r = {
    prefix: e.prefix
  });
  var a = new o(r);
  if ("production" !== process.env.NODE_ENV && /[^a-z-]/.test(t)) throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
  var n,
    s,
    c = {};
  if (g) {
    n = e.container || document.head;
    var l = document.querySelectorAll("style[data-emotion-" + t + "]");
    Array.prototype.forEach.call(l, function (e) {
      e.getAttribute("data-emotion-" + t).split(" ").forEach(function (e) {
        c[e] = !0;
      }), e.parentNode !== n && n.appendChild(e);
    });
  }
  if (g) a.use(e.stylisPlugins)(p), s = function (e, r, t, n) {
    var s = r.name;
    if (b.current = t, "production" !== process.env.NODE_ENV && void 0 !== r.map) {
      var c = r.map;
      b.current = {
        insert: function (e) {
          t.insert(e + c);
        }
      };
    }
    a(e, r.styles), n && (h.inserted[s] = !0);
  };else {
    a.use(v);
    var u = k;
    (e.stylisPlugins || void 0 !== e.prefix) && (a.use(e.stylisPlugins), u = w(e.stylisPlugins || k)(e.prefix));
    s = function (e, r, t, n) {
      var s = r.name,
        c = function (e, r) {
          var t = r.name;
          return void 0 === u[t] && (u[t] = a(e, r.styles)), u[t];
        }(e, r);
      return void 0 === h.compat ? (n && (h.inserted[s] = !0), "development" === process.env.NODE_ENV && void 0 !== r.map ? c + r.map : c) : n ? void (h.inserted[s] = c) : c;
    };
  }
  if ("production" !== process.env.NODE_ENV) {
    var f = /\/\*/g,
      d = /\*\//g;
    a.use(function (e, r) {
      switch (e) {
        case -1:
          for (; f.test(r);) {
            if (d.lastIndex = f.lastIndex, !d.test(r)) throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            f.lastIndex = d.lastIndex;
          }
          f.lastIndex = 0;
      }
    }), a.use(function (e, r, t) {
      switch (e) {
        case -1:
          var a = r.match(/(:first|:nth|:nth-last)-child/g);
          a && !0 !== h.compat && a.forEach(function (e) {
            var t = new RegExp(e + ".*\\/\\* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason \\*\\/").test(r);
            e && !t && console.error('The pseudo class "' + e + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + e.split("-child")[0] + '-of-type".');
          });
      }
    });
  }
  var h = {
    key: t,
    sheet: new i({
      key: t,
      container: n,
      nonce: e.nonce,
      speedy: e.speedy
    }),
    nonce: e.nonce,
    inserted: c,
    registered: {},
    insert: s
  };
}({
  stylisPlugins: [(f = "#themed", d = f.trim() + " ", h = new WeakSet(), function (e, r, t, a, n, s, c, i) {
    if (2 === e && 107 !== i && !h.has(t)) {
      h.add(t);
      for (var o = 0; o < t.length; o++) t[o] = "" + d + t[o];
    }
  })]
});
var m,
  y,
  C,
  A = t.createContext({
    style: {},
    variables: {},
    cssVariables: {}
  });
e(C || (m = ["\n  svg {\n    fill: currentColor;\n  }\n"], y = ["\n  svg {\n    fill: currentColor;\n  }\n"], Object.defineProperty ? Object.defineProperty(m, "raw", {
  value: y
}) : m.raw = y, C = m));
var x = function (e) {
    var t = e.children,
      n = e.className,
      i = e.alignCellsTop,
      o = e.layoutAuto,
      l = e.filled,
      u = e.bordered,
      f = e.striped,
      d = c(e, ["children", "className", "alignCellsTop", "layoutAuto", "filled", "bordered", "striped"]),
      h = function () {
        for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
        return e.filter(function (e) {
          return e;
        }).join(" ");
      }("ef-table", i ? "-align-cells-top" : "", o ? "-layout-auto" : "", l ? "-filled" : "", u ? "-bordered" : "", f ? "-striped" : "", n || ""),
      b = a(A).style;
    return r("div", {
      className: "ef-table-w"
    }, r("table", s({
      css: b.Table,
      className: h
    }, d), t));
  },
  O = n({
    name: ""
  });
x.Head = function (e) {
  var t = e.children,
    n = c(e, ["children"]),
    i = a(A).style;
  return r(O.Provider, {
    value: {
      name: "Head"
    }
  }, r("thead", s({
    css: i.TableHead
  }, n), t));
}, x.Footer = function (e) {
  var t = e.children,
    n = c(e, ["children"]),
    i = a(A).style;
  return r("tfoot", s({
    css: i.TableFooter
  }, n), t);
}, x.Body = function (e) {
  var t = e.children,
    n = c(e, ["children"]),
    i = a(A).style;
  return r("tbody", s({
    css: i.TableBody
  }, n), t);
}, x.Row = function (e) {
  var t = e.children,
    n = c(e, ["children"]),
    i = a(A).style;
  return r("tr", s({
    css: i.TableRow
  }, n), t);
}, x.Cell = function (e) {
  var t = e.children,
    n = c(e, ["children"]),
    i = a(A).style,
    o = a(O).name;
  return r("Head" === o ? "th" : "td", s({
    css: i.TableCell
  }, n), t);
};
export { x as Table };